import { render, staticRenderFns } from "./SelectCreateOrgBusiness.vue?vue&type=template&id=8dd57064&scoped=true"
import script from "./SelectCreateOrgBusiness.vue?vue&type=script&lang=js"
export * from "./SelectCreateOrgBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd57064",
  null
  
)

export default component.exports